import SIMPLE_DATE_RANGE from "@app/scene/home/util/simple-date-range";

const getGranularity = (rangeLabel: string) =>
  SIMPLE_DATE_RANGE.find(({ label }) => label === rangeLabel)?.granularity;

export default getGranularity;
